export default __webpack_public_path__ + "static/media/airplane.33c17b63.jpg";